export const purchaseUrls = {
  base: 'https://www.compradigitalya.com/cart/43024349954119:1',
  premium: 'https://www.compradigitalya.com/cart/43024350969927:1',
}

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/23b9Yf8sdSF97UvctmJoVs/ChatGPT_Image_30_jul_2026,_05_21_59_p.m..png'

export const testimonials = [
  {
    initials: 'MG',
    name: 'Matías G.',
    place: 'Buenos Aires, Argentina · 31 años · Entrenador Personal',
    text: 'Trabajo como personal trainer y siempre tenía miedo de hacer la rehabilitación de hombro mal. Con el Tomo 1 pude estructurar el proceso fase por fase. Mis clientes volvieron a entrenar sin dolor y sin miedo a re-lesionarse.',
  },
  {
    initials: 'LM',
    name: 'Laura M.',
    place: 'Córdoba, Argentina · 38 años · Deportista Amateur',
    text: 'Me operé la rodilla y no sabía cómo retomar los entrenamientos. El Tomo 2 me dio exactamente lo que necesitaba: fases claras, ejercicios con series y repeticiones, y criterios para saber cuándo avanzar. Lo recomiendo a cualquiera que no quiera improvisar.',
  },
  {
    initials: 'FR',
    name: 'Federico R.',
    place: 'Rosario, Argentina · 35 años · Profesor de Educación Física',
    text: 'Soy profe de educación física y tenía alumnos con tobillo inestable crónico que se re-lesionaban cada temporada. Después de aplicar el protocolo del Tomo 3, ninguno volvió a faltar por esguince en toda la temporada.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Rehabilitación de Hombro',
    period: 'Método Progresión Blindada',
    content: [
      'Protocolo completo de 5 fases: movilidad, activación, fortalecimiento, estabilidad y retorno.',
      '25+ ejercicios con posición exacta, ejecución, series, repeticiones y criterios de avance.',
      'Checklist de evaluación por fase antes de avanzar.',
      'Protocolo de retorno al entrenamiento de press y movimientos de hombro.',
      'Planilla de seguimiento semanal lista para usar.',
    ],
  },
  {
    icon: '📗',
    name: 'Rehabilitación de Rodilla',
    period: 'Método Progresión Blindada',
    content: [
      'Protocolo completo para el síndrome patelofemoral, tendinitis rotuliana y ligamentos.',
      'Control del valgo dinámico: el ejercicio más ignorado en la rehabilitación de rodilla.',
      'Fortalecimiento de glúteos como base de la salud de la rodilla.',
      'Propiocepción progresiva desde la Fase 2 hasta el retorno deportivo.',
      'Protocolo de retorno a deportes de impacto y cambio de dirección.',
    ],
  },
  {
    icon: '📙',
    name: 'Rehabilitación de Tobillo',
    period: 'Método Progresión Blindada',
    content: [
      'El sistema para cortar el ciclo vicioso del esguince recurrente de una vez.',
      'Protocolo de fortalecimiento de peroneales con carga excéntrica progresiva.',
      'Propiocepción reactiva: el entrenamiento que el 70% de las personas nunca hace.',
      'Retorno al trote en terreno irregular, deportes de cancha y superficies inestables.',
      'Sistema de mantenimiento permanente para prevenir re-lesiones de por vida.',
    ],
  },
  {
    icon: '📕',
    name: 'Rehabilitación de Codo y Muñeca',
    period: 'Método Progresión Blindada',
    content: [
      'Protocolo excéntrico completo para epicondilitis lateral y medial.',
      'Tyler Twist y protocolo Alfredson modificado: los ejercicios con mayor evidencia disponible.',
      'Fuerza de agarre progresiva para el retorno al deporte y al trabajo manual.',
      'Protocolo de retorno al tenis, pádel, CrossFit y trabajo de oficina.',
      'Sistema de pausas activas para prevención permanente en trabajadores.',
    ],
  },
  {
    icon: '📓',
    name: 'Rehabilitación de Columna y Cadera',
    period: 'Método Progresión Blindada',
    content: [
      'Core real: transverso, multífido, diafragma y suelo pélvico. No abdominales superficiales.',
      'El patrón de bisagra de cadera que protege la columna en todos los gestos de levantamiento.',
      'Protocolo para hernia de disco, lumbalgia mecánica, síndrome piriforme y ciática muscular.',
      'Cervical, dorsal y lumbar: trabajo completo de toda la columna en un solo protocolo.',
      'Sistema de mantenimiento y pausas activas para oficina y trabajo manual.',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🦴',
    'Movilidad para Todas las Articulaciones',
    'Rutinas de movilidad activa para hombro, rodilla, tobillo, codo, muñeca, columna y cadera. El Framework M.A.P.A. aplicado a cada articulación. Rutina express de 10 minutos y rutina completa de 25 minutos listas para usar antes de rehabilitar o entrenar.',
    '$12.000',
  ],
  [
    '02',
    '🏠',
    'Ejercicios de Rehabilitación para Casa',
    'Protocolos completos con peso corporal, silla, pared, toalla y botella de agua. Sin gimnasio, sin máquinas, sin excusas. Rutina express de 15 minutos y rutina completa de 30 minutos. Plan semanal de 7 días listo para empezar hoy.',
    '$12.000',
  ],
  [
    '03',
    '🏋️',
    'Ejercicios de Rehabilitación en Gimnasio',
    'Cómo usar máquinas, poleas, bandas elásticas, mancuernas y barras para rehabilitar con criterio y sin improvisar. El Semáforo de Cargas para saber cuándo subir peso. Rutinas de 25 y 50 minutos organizadas por articulación.',
    '$14.000',
  ],
  [
    '04',
    '🛡️',
    'Prevención de Lesiones y Fortalecimiento Articular',
    'El sistema para que el cuerpo no vuelva a fallar en el mismo lugar. El Framework A.R.M.A. Protocolo de mantenimiento permanente de 2 días por semana. Checklist mensual de salud articular y plan preventivo de 4 semanas.',
    '$12.000',
  ],
  [
    '05',
    '🔥',
    'Calentamientos y Estiramientos para Cada Articulación',
    'Protocolos específicos de calentamiento dinámico y estiramientos de descarga para hombro, rodilla, tobillo, codo, muñeca, columna y cadera. Rutinas por deporte: fútbol, running, gym, tenis y oficina. Protocolos express de 5 minutos por articulación.',
    '$10.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si recién empiezo a trabajar con pacientes o alumnos lesionados?',
    'Sí. El sistema está diseñado para que cualquier profesional del movimiento, aunque no tenga formación específica en kinesiología, pueda aplicar los protocolos de forma segura y efectiva. Cada ejercicio tiene posición exacta, ejecución paso a paso, series, repeticiones y criterios claros de progresión. No necesitás adivinar nada.',
  ],
  [
    '¿Cómo recibo el material?',
    'Al completar el pago recibís un correo electrónico con el acceso a todos los PDF en menos de 5 minutos. El material es tuyo para siempre, podés descargarlo y usarlo cuando quieras.',
  ],
  [
    '¿La garantía es real?',
    '100% real. Tenés 7 días desde la compra para revisar todo el material. Si sentís que no era lo que esperabas, escribís a compradigitayaa@gmail.com y te devolvemos el dinero completo. Sin formularios, sin preguntas, sin vueltas.',
  ],
  [
    '¿Qué necesito para empezar?',
    'Solo un dispositivo para leer PDF: celular, tablet o computadora. Los ejercicios de los primeros tomos no requieren equipamiento. A partir de la Fase 3 se introducen bandas elásticas, mancuernas y poleas, siempre con alternativas de peso corporal para quienes trabajan en casa.',
  ],
  [
    '¿Sirve para personas que no son profesionales del deporte?',
    'Sí. El material está escrito en un lenguaje claro, sin jerga médica compleja. Cualquier persona con una lesión que quiera rehabilitarse de forma autónoma puede seguir los protocolos paso a paso. El aviso importante de cada tomo indica cuándo es necesario consultar con un profesional.',
  ],
  [
    '¿Puedo usarlo para dar clases o sesiones de entrenamiento?',
    'Sí. Está pensado para profesores de educación física, entrenadores personales y preparadores físicos que necesitan una guía práctica y estructurada para trabajar con alumnos o pacientes lesionados. Cada ejercicio incluye todos los datos necesarios para indicárselo con precisión.',
  ],
  [
    '¿Está adaptado a Argentina y puedo imprimirlo?',
    'Sí a las dos cosas. La terminología, los ejemplos, los deportes y los precios están adaptados a Argentina, y todos los PDF están optimizados para impresión, incluidas las planillas de seguimiento semanal de cada tomo.',
  ],
] as const

export const recentPurchases = [
  ['Matías G.', 'Buenos Aires', 'Combo Completo Rehabilitación'],
  ['Laura M.', 'Córdoba', 'Rehabilitación + Programa de Retorno'],
  ['Federico R.', 'Rosario', 'Combo Completo Rehabilitación'],
  ['Carolina P.', 'Mendoza', 'Rehabilitación + Programa de Retorno'],
  ['Diego S.', 'La Plata', 'Combo Completo Rehabilitación'],
  ['Valentina T.', 'Mar del Plata', 'Rehabilitación + Programa de Retorno'],
  ['Nicolás B.', 'Salta', 'Combo Completo Rehabilitación'],
  ['Romina L.', 'Neuquén', 'Combo Completo Rehabilitación'],
  ['Emiliano C.', 'San Miguel de Tucumán', 'Rehabilitación + Programa de Retorno'],
  ['Gabriela F.', 'Bahía Blanca', 'Combo Completo Rehabilitación'],
] as const
